import React, { Component } from 'react'
import { connect } from 'react-redux'
import PaymentSummary from './PaymentSummary'
import SaveAppointment from './Save/Save'
import RecurrenceSummary from 'cogsworth/components/RecurrenceSummary/RecurrenceSummary'
import CouponCode from 'cogsworth/components/CouponCode/CouponCode'
import { injectValuesIntoTemplate } from '../../utils/templates'

import './BookingSummary.css'

class BookingSummary extends Component {
  navigateTo(e) {
    const element = e.target.closest('nav')
    if (!element) {
      return
    }
    const navToStep = element.getAttribute('data-field')
    if (navToStep) {
      const { fields, navigate } = this.props
      const fieldIndex = fields.filter(f => !f.hidden).findIndex(f => f.id === navToStep)
      if (fieldIndex > -1) {
        navigate(fieldIndex)
      }
    }
  }

  renderPreviewNotice() {
    return (
      <div className="preview-alert">
        This business is in preview mode and can't accept bookings yet.
      </div>
    )
  }

  render() {
    const { business, booking } = this.props
    const service = business.services.find(s => s.id === booking.serviceId)

    let answers = booking.answers
    if (this.props.rescheduling && answers.length === 0) {
      answers = this.props.rescheduling.answers || []
    }

    // This is sanitized in the backend
    const contentHtml = injectValuesIntoTemplate(business.bookingTemplatesHtml["confirmation-screen"], {
      service,
      booking: {
        ...(this.props.rescheduling || {}),
        ...booking,
        answers,
      },
      dateFormat: business.dateFormat,
      payOnArrival: this.props.payOnArrival,
      visibleFields: this.props.fields.filter(f => !f.hidden).map(f => f.id),
      coupon: this.props.coupon,
    })

    return (
      <div className="booking-summary">
        <div className="inner">
          <div className="booking-summary-content" onClick={this.navigateTo.bind(this)} dangerouslySetInnerHTML={{ __html: contentHtml }} />
          <PaymentSummary />
          { service.recurrence && !this.props.rescheduling &&  <RecurrenceSummary business={business} service={service} count={5} dateFormat={business.dateFormat} />}
          <CouponCode booking={this.props.booking} business={business} />
          { !business.previewMode && <SaveAppointment {...this.props} /> }
          { business.previewMode && this.renderPreviewNotice() }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  coupon: state.coupon,
})
export default connect(mapStateToProps)(BookingSummary)
